import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal } from 'components'

export default class ModalConfirm extends PureComponent {
  static propTypes = {
    onClickConfirm: PropTypes.func.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
  }

  onClickConfirm = () => {
    this.props.onClickConfirm()
    this.props.toggleModal('delete')
  }

  onClickCancel = () => {
    this.props.onClickCancel()
    this.props.toggleModal('delete')
  }

  render() {
    const { isOpen, companyName } = this.props
    return (
      <Modal
        id="confirm_id"
        className="supplier-form theme-blue"
        isOpen={isOpen}
        modalWidth="575px"
      >
        <Modal.Header>Confirm</Modal.Header>

        <Modal.Body>
          <p className="default text-center">
            Are you sure to cancel invite? <br />
            {companyName}
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            id="close_modal_history_id"
            className="theme-border-gray"
            onClick={() => this.onClickCancel()}
          >
            Cancel
          </Button>

          <Button
            id="close_modal_history_id"
            className="theme-green"
            onClick={() => this.onClickConfirm()}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}
ModalConfirm.defaultProps = {
  onClickCancel: () => {},
  onClickConfirm: () => {},
  isOpen: false,
  companyName: '',
}
